import React from 'react';
import HeroSection from '../components/HeroSection';
import ValdelsaGallery from '../components/ValdelsaGallery';
import WallOfFame from '../components/WallOfFame';
import VisionaryQuote from '../components/VisionaryQuote';
import FoundersSection from '../components/FoundersSection';
import HubComparison from '../components/HubComparison';
import CommunityCounter from '../components/CommunityCounter';
import ServicesPreview from '../components/ServicesPreview';
import MaieuticaCTA from '../components/MaieuticaCTA';
import DoposcuolaSportivo from '../components/DoposcuolaSportivo';
import DoposcuolaStage from '../components/DoposcuolaStage';
import SostieniciSection from '../components/SostieniciSection';
import MerchSection from '../components/MerchSection';
import StartupCTA from '../components/StartupCTA';
import VisionarySearch from '../components/VisionarySearch';

const HomePage = () => (
  <main data-testid="home-page">
    <HeroSection />
    <ValdelsaGallery />
    <WallOfFame />
    <FoundersSection />
    <VisionaryQuote />
    <CommunityCounter />
    <HubComparison />
    <ServicesPreview />
    <MaieuticaCTA />
    <DoposcuolaSportivo />
    <DoposcuolaStage />
    <SostieniciSection />
    <MerchSection />
    <VisionarySearch />
    <StartupCTA />
  </main>
);

export default HomePage;
